import { FeatureFlag } from 'core/enums/feature-flag';
import { PermissionType } from 'core/enums/permission-type';

// NOTE: these will be used regardless of what is set in Umbraco (this is to reduce noise in the config). Remove from here to active feature flag from Umbraco
export const DefaultFeatureFlags = {
  [FeatureFlag.InlineMenu]: PermissionType.View,
  //View Balance
  [FeatureFlag.ViewBalanceQuickLinks]: PermissionType.View,
  [FeatureFlag.ViewBalancePendingQuotes]: PermissionType.View,
  [FeatureFlag.AllowStandardAmountToPayEdit]: PermissionType.Edit,
  // Dashboard
  [FeatureFlag.DashboardFilterBar]: PermissionType.View,
  [FeatureFlag.DashboardTabViews]: PermissionType.View,
  [FeatureFlag.DashboardQuickLinks]: PermissionType.View,
//  [FeatureFlag.DashboardContractExpirationBanner]: PermissionType.View,
  // Transaction History
  [FeatureFlag.TransactionHistoryFilterBar]: PermissionType.View,
  [FeatureFlag.TransactionHistoryTableHeaderCard]: PermissionType.View,
  // [FeatureFlag.TransactionHistoryCalenderSelection]: PermissionType.View,
  // Menu
  [FeatureFlag.MenuProfileCard]: PermissionType.View,
  [FeatureFlag.MenuAmountToPayCard]: PermissionType.View,
  // Fix Error
  [FeatureFlag.FixErrorForm]: PermissionType.View,
  // Subscriptions
  [FeatureFlag.SubscriptionFilterBar]: PermissionType.View,
  [FeatureFlag.SubscriptionTabViews]: PermissionType.View,
  [FeatureFlag.InsuranceFuneralCoverFamilyPlans]: PermissionType.View,
  [FeatureFlag.InsuranceFuneralCoverPersonal]: PermissionType.View,
  [FeatureFlag.LandingLinkCard]: PermissionType.View,
  [FeatureFlag.LandingExploreCard]: PermissionType.View,
  // [FeatureFlag.ShowLandingCards]: PermissionType.View,
  // [FeatureFlag.HardcodedAnywhereStreams]: PermissionType.View,
  // [FeatureFlag.ActionFeatureStreamMonthlyToBundle]: PermissionType.View,
  // [FeatureFlag.ActionFeatureStreamRenewBundle]: PermissionType.View,
  // [FeatureFlag.BrandMissMatchPopup]: PermissionType.None,
  // [FeatureFlag.AllowGotvInterface]: PermissionType.None,
  // [FeatureFlag.LandingActivateCard]: PermissionType.View,
  // [FeatureFlag.HasShowmaxPL]: PermissionType.Edit
  // [FeatureFlag.LinkPackageEmailStep]: PermissionType.Edit,
  // [FeatureFlag.LiveChatIFrame]: PermissionType.View
  // [FeatureFlag.AccountTsAndCsBanner]: PermissionType.View,
  // [FeatureFlag.AccountTsAndCsBannerUseMahLink]: PermissionType.None,
  // [FeatureFlag.AccountTsAndCsApply]: PermissionType.View,
  // [FeatureFlag.BlockLesothoPayments]: PermissionType.View
  // [FeatureFlag.ProfileUpdateOTP]: PermissionType.View,
  // [FeatureFlag.UserBasedUrlLocale]: PermissionType.View,
  // [FeatureFlag.UseFixErrorV2]: PermissionType.View,
  // [FeatureFlag.ShowNotListedOption]: PermissionType.View,
  // [FeatureFlag.ActionFeatureDashboardChangePackage]: PermissionType.View
  // [FeatureFlag.ActionFeatureManageMembers]: PermissionType.View,
  // [FeatureFlag.ProfileUpdate]: PermissionType.View,
  // [FeatureFlag.DetailedRewardSummary]: PermissionType.View,
  // [FeatureFlag.RewardsPremiumTier]: PermissionType.Edit,
  // [FeatureFlag.RewardsPremiumCoinsOnlySummary]: PermissionType.View
  // [FeatureFlag.ActionFeatureDisconnectPackage]: PermissionType.None,
  // [FeatureFlag.ActionFeatureDisconnectDishlessPackage]: PermissionType.None,
  // [FeatureFlag.ProductDisconnection]: PermissionType.None,
  // [FeatureFlag.DashboardPaymentReminderPopup]: PermissionType.None
  // [FeatureFlag.DashboardPaymentReminderAnnouncement]: PermissionType.None
  // [FeatureFlag.SwitchToDebitOrderSuccessScreen]: PermissionType.View,
  // [FeatureFlag.DashboardGenericPopupCampaigns]: PermissionType.View,
  // [FeatureFlag.SubscriptionUpsized]: PermissionType.View,
};

// NOTE: these will be used when running app in dev mode.
export const DevFeatureFlags = {
  //View Balance
  [FeatureFlag.ViewBalanceDownloadLatestStatementCard]: PermissionType.View,
  [FeatureFlag.ViewBalancePriceAdjustmentCard]: PermissionType.View,
  [FeatureFlag.ViewBalancePaymentType]: PermissionType.View,
  [FeatureFlag.ViewBalanceLastTransactionCard]: PermissionType.View,
  [FeatureFlag.ViewBalanceShowPaymentNotice]: PermissionType.View,
  [FeatureFlag.ViewBalanceQuickLinks]: PermissionType.View,
  [FeatureFlag.ViewBalancePendingQuotes]: PermissionType.View,
  [FeatureFlag.ViewBalanceCurrencyConversion]: PermissionType.View,
  [FeatureFlag.ViewBalanceAccountDetails]: PermissionType.View,
  // Dashboard
  [FeatureFlag.DashboardViewingRoute]: PermissionType.Route,
  [FeatureFlag.DashboardInternetRoute]: PermissionType.Route,
  [FeatureFlag.DashboardInsuranceRoute]: PermissionType.Route,
  [FeatureFlag.DashboardInactiveRoute]: PermissionType.Route,
  [FeatureFlag.DashboardAnnouncementBanner]: PermissionType.View,
  [FeatureFlag.DashboardFilterBar]: PermissionType.View,
  [FeatureFlag.DashboardTabViews]: PermissionType.View,
  [FeatureFlag.DashboardQuickLinks]: PermissionType.View,
  // [FeatureFlag.DashboardPendingQuotes]: PermissionType.View,
  // Transaction History
  [FeatureFlag.TransactionHistoryFilterBar]: PermissionType.View,
  [FeatureFlag.TransactionHistoryTableHeaderCard]: PermissionType.View,
  [FeatureFlag.TransactionHistoryCalenderSelection]: PermissionType.View,
  // Route access
  [FeatureFlag.BillingExplainedRoute]: PermissionType.Route,
  [FeatureFlag.ViewBalanceRoute]: PermissionType.Route,
  [FeatureFlag.MonthlyStatementsRoute]: PermissionType.Route,
  [FeatureFlag.UpdatePaymentMethodsRoute]: PermissionType.Route,
  [FeatureFlag.AccountRoute]: PermissionType.Route,
  [FeatureFlag.TransactionHistoryRoute]: PermissionType.Route,
  [FeatureFlag.AmountToPayRoute]: PermissionType.Route,
  [FeatureFlag.DashboardRoute]: PermissionType.Route,
  [FeatureFlag.ProductsRoute]: PermissionType.Route,
  [FeatureFlag.FixErrorRoute]: PermissionType.Route,
  [FeatureFlag.OffersRoute]: PermissionType.Route,
  [FeatureFlag.RewardsRoute]: PermissionType.Route,
  [FeatureFlag.ProfileRoute]: PermissionType.Route,
  [FeatureFlag.ActionRoute]: PermissionType.Route,
  // Fix Error
  [FeatureFlag.FixErrorForm]: PermissionType.View,
  // Profile
  [FeatureFlag.ProfileRewardsCard]: PermissionType.View,
  [FeatureFlag.ProfilePreferences]: PermissionType.View,
  [FeatureFlag.ProfilePostalAddress]: PermissionType.View,
  [FeatureFlag.ProfilePicture]: PermissionType.View,
  [FeatureFlag.ProfileDataRequest]: PermissionType.View,
  [FeatureFlag.ProfileOptionalEmail]: PermissionType.None,
  // Other
  [FeatureFlag.DevTools]: PermissionType.View,
  [FeatureFlag.ScheduledMaintenancePanel]: PermissionType.None,
  [FeatureFlag.UnexpectedMaintenancePanel]: PermissionType.None,
  // Menu
  [FeatureFlag.MenuProfileCard]: PermissionType.View,
  [FeatureFlag.MenuAmountToPayCard]: PermissionType.View,
  // subscriptions
  [FeatureFlag.SubscriptionsRoute]: PermissionType.Route,
  [FeatureFlag.SubscriptionViewingRoute]: PermissionType.Route,
  [FeatureFlag.SubscriptionInactiveRoute]: PermissionType.Route,
  [FeatureFlag.SubscriptionPendingRoute]: PermissionType.Route,
  [FeatureFlag.SubscriptionFilterBar]: PermissionType.View,
  [FeatureFlag.SubscriptionTabViews]: PermissionType.View,
  [FeatureFlag.SubscriptionLinkPackageSA]: PermissionType.View,
  [FeatureFlag.LinkPackageQuoteBreakdown]: PermissionType.View,
  [FeatureFlag.HardcodedAnywhereStreams]: PermissionType.View,
  // rewards
  [FeatureFlag.WhatIsRewardsRoute]: PermissionType.Route,
  [FeatureFlag.AvailableRewardsRoute]: PermissionType.Route,
  [FeatureFlag.EarnMoreStarsRoute]: PermissionType.Route,
  [FeatureFlag.CompetitionsRoute]: PermissionType.Route,
  [FeatureFlag.RewardsHistoryRoute]: PermissionType.Route,
  // actions
  [FeatureFlag.ProductDisconnection]: PermissionType.View,
  // insurance
  [FeatureFlag.InternetRoute]: PermissionType.Route,
  [FeatureFlag.InsuranceRoute]: PermissionType.Route,
  [FeatureFlag.InsurancePolicyUpdateAnnouncementBanner]: PermissionType.View,
  [FeatureFlag.RewardsPremiumStatusRoute]: PermissionType.Route,
  [FeatureFlag.RewardsWhatIsPremiumRoute]: PermissionType.Route,
  [FeatureFlag.LinkCustomerWithIdentityNumber]: PermissionType.Route,
  [FeatureFlag.XtraView]: PermissionType.View,
  [FeatureFlag.InsuranceFuneralCoverFamilyPlans]: PermissionType.View,
  [FeatureFlag.InsuranceFuneralCoverPersonal]: PermissionType.View,
  // [FeatureFlag.BypassReconnections]: PermissionType.View,
  [FeatureFlag.ActionFeatureActivate]: PermissionType.View,
  [FeatureFlag.ActionFeatureLinkPackage]: PermissionType.View,
  [FeatureFlag.ActionFeatureChangePackage]: PermissionType.View,
  [FeatureFlag.ActionFeatureReconnectPackage]: PermissionType.View,
  [FeatureFlag.ActionFeatureDisconnectPackage]: PermissionType.View,
  [FeatureFlag.ActionFeatureCancelShowmax]: PermissionType.View,
  [FeatureFlag.ActionFeatureCancelBritbox]: PermissionType.View,
  [FeatureFlag.ActionFeatureRedeemVoucher]: PermissionType.View,
  [FeatureFlag.ActionFeatureMonthlyToBundle]: PermissionType.View,
  [FeatureFlag.ActionFeatureStreamMonthlyToBundle]: PermissionType.View,
  [FeatureFlag.ActionFeatureSwitchToStream]: PermissionType.View,
  [FeatureFlag.ActionFeatureGetQuote]: PermissionType.View,
  [FeatureFlag.ActionFeatureCaptureBundle]: PermissionType.View,
  [FeatureFlag.ActionFeatureCreateXtraview]: PermissionType.View,
  [FeatureFlag.ActionFeatureInsureDecoder]: PermissionType.View,
  [FeatureFlag.ActionFeatureCancelInsurance]: PermissionType.View,
  [FeatureFlag.ActionFeatureManageBeneficiaries]: PermissionType.View,
  [FeatureFlag.ActionFeatureManageMembers]: PermissionType.View,
  [FeatureFlag.ActionFeatureAddBeneficiary]: PermissionType.View,
  [FeatureFlag.ActionFeatureClearErrorCode]: PermissionType.View,
  [FeatureFlag.ActionFeatureViewLinked]: PermissionType.View,
  [FeatureFlag.ActionFeatureProductHighlights]: PermissionType.View,
  [FeatureFlag.ActionFeatureOtherAddOns]: PermissionType.View,
  [FeatureFlag.UseGhostAcceptQuote]: PermissionType.View,
  [FeatureFlag.HasShowmax]: PermissionType.Edit,
  [FeatureFlag.HasShowmaxPL]: PermissionType.Edit,
  [FeatureFlag.HasBritbox]: PermissionType.Edit,
  [FeatureFlag.HasNetflix]: PermissionType.Edit,
  [FeatureFlag.HasDisney]: PermissionType.Edit,
  [FeatureFlag.HasMobileStream]: PermissionType.Edit,
  [FeatureFlag.ShowPaymentMinimumAmountNotice]: PermissionType.View,
};